<template>
  <WizardStep name="address">
    <div class="row">
      <div class="col-md-10">
        <FieldGroup title="Wie lautet Deine aktuelle Anschrift?">
          <div class="row">
            <div class="col-md-6">
              <SelectField
                name="country"
                placeholder="Land"
                :options="formContext.getOptionSet('countries')"
              />
            </div>
          </div>
          <TextField name="street" placeholder="Straße, Nr." />
          <div class="row">
            <div class="col-md-6">
              <TextField name="postalCode" placeholder="PLZ" />
            </div>
            <div class="col-md-6">
              <TextField name="city" placeholder="Stadt" />
            </div>
          </div>
        </FieldGroup>
      </div>
    </div>
    <Panel
      slot="footer"
      title="Ich komme nicht aus Deutschland. Welchen Aufenthaltsstatus brauche ich?"
    >
      Das hängt von Deinem Heimatland ab. Wenn Du Zweifel hast, findest Du hier
      <a
        href="https://www.arbeitsagentur.de/fuer-menschen-aus-dem-ausland/voraussetzungen-arbeiten-in-deutschland"
        target="_blank"
      >
        mehr Informationen
      </a>
      .
    </Panel>
  </WizardStep>
</template>

<script>
import formContextAware from '../mixin/formContextAware';

export default {
  mixins: [formContextAware],
};
</script>
